/**
 * L'heure réelle d'un événement, à Paris.
 *
 * Les champs date_start / date_end sont marqués « +00:00 », mais ce n'est
 * pas de l'UTC. Le jeu de données y écrit l'heure locale, en rajoutant une
 * seconde fois l'heure d'été. Mesuré sur 240 fiches en comparant à l'horaire
 * de leur description : une heure de trop d'avril à octobre, aucune en hiver.
 *
 * Les convertir comme de l'UTC, ce que fait n'importe quel navigateur,
 * ajoutait encore deux heures en été. Résultat, avant ce correctif : 217
 * cartes sur 219 affichaient une heure fausse, toutes de trois heures, et
 * 15 soirées basculaient au lendemain. Le concert du 21 à 21h30 apparaissait
 * au 22 à 0h30.
 *
 * On lit donc l'horloge telle qu'écrite, sans conversion, et on retire
 * l'heure d'été quand la date y tombe.
 *
 * Une exception : le couple 00:00 → 23:59 ne décrit pas un horaire mais des
 * journées entières. Le décaler ferait commencer la veille au soir une série
 * qui démarre un matin.
 */

const DECALAGE = new Intl.DateTimeFormat("en-US", {
  timeZone: "Europe/Paris",
  timeZoneName: "shortOffset",
});

function enHeureDete(an, mois, jour, h, min) {
  // Sondée à l'instant même, et non à midi : la nuit du changement d'heure,
  // une soirée écrite 00:55 le 25 octobre a lieu le 24 à 23h55, encore en
  // heure d'été. Sondée à midi le 25, elle passait pour de l'heure d'hiver
  // et s'affichait au lendemain.
  const sonde = new Date(Date.UTC(an, mois, jour, h, min));
  const nom = DECALAGE.formatToParts(sonde).find((p) => p.type === "timeZoneName")?.value || "";
  return nom.includes("+2");
}

function lire(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(iso || "");
  if (!m) return null;
  return { an: +m[1], mois: +m[2] - 1, jour: +m[3], h: +m[4], min: +m[5] };
}

/**
 * Début et fin ramenés à l'heure de Paris.
 *
 * Les Date renvoyées portent l'heure de Paris dans leurs composantes UTC :
 * il faut donc les formater avec `timeZone: "UTC"`, jamais avec le fuseau
 * du navigateur, sans quoi la conversion fautive revient par la fenêtre.
 */
export function datesLocales(debutIso, finIso) {
  const a = lire(debutIso);
  const b = lire(finIso);
  const journeesEntieres = !!(a && b && a.h === 0 && a.min === 0 && b.h === 23 && b.min >= 59);

  const versParis = (x) => {
    if (!x) return null;
    const t = new Date(Date.UTC(x.an, x.mois, x.jour, x.h, x.min));
    if (!journeesEntieres && enHeureDete(x.an, x.mois, x.jour, x.h, x.min)) {
      t.setUTCHours(t.getUTCHours() - 1);
    }
    return t;
  };

  return { debut: versParis(a), fin: versParis(b), journeesEntieres };
}
